import customHistory from '../customHistory';
import { handleRequestErrors } from "../services/handleRequestError";

let selectedCustomersRequestId = 0;

export const fetchContactGroup = (id) => {
  const endpoint = `/api/v1/contact_groups/${id}`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: "SET_CONTACT_GROUP", data }),
        (err) => dispatch({ type: "LOAD_DATA_FAILURE", err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const fetchCustomers = (page = 1, params) => {
  let endpoint = `/api/v1/contact_groups/customers?page=${page}`;

  if (params !== null && params !== undefined) {
    // eslint-disable-next-line no-undef
    endpoint += `&${$.param(params)}`;
  }

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: "SET_CUSTOMERS", data }),
        (err) => dispatch({ type: "LOAD_DATA_FAILURE", err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const fetchSelectedCustomers = (page = 1, params) => {
  let endpoint = `/api/v1/contact_groups/customers?page=${page}`;

  if (params !== null && params !== undefined) {
    // eslint-disable-next-line no-undef
    endpoint += `&${$.param(params)}`;
  }

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: "SET_SELECTED_CUSTOMERS", data }),
        (err) => dispatch({ type: "LOAD_DATA_FAILURE", err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const fetchDefaultSelectedCustomers = (id, page = 1, params) => {
  let endpoint = `/api/v1/contact_groups/${id}/selected_customers?page=${page}`;

  if (params !== null && params !== undefined) {
    // eslint-disable-next-line no-undef
    endpoint += `&${$.param(params)}`;
  }

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: "SET_SELECTED_CUSTOMER_IDS", data }),
        (err) => dispatch({ type: "LOAD_DATA_FAILURE", err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const fetchTags = () => {
  const endpoint = `/api/v1/tags`;

  return (dispatch) => fetch(endpoint, {
    method: "GET",
    credentials: "same-origin",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json"
    }
  })
    .then((res) => res.json())
    .then(
      (data) => dispatch({ type: "SET_TAGS", data }),
      (err) => dispatch({ type: "LOAD_DATA_FAILURE", err })
    ).catch((error) => {
      if (error.response) alert(error.response);
      else alert("An unexpected error occurred.");
    });
};

export const createContactGroup = (body, csrfToken) => {
  const endpoint = `/api/v1/contact_groups`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "POST",
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/plain, */*'
      },
      body: JSON.stringify(body)
    })
      .then((res) => res.json())
      .then(
        (data) => {
          if (data.errors) {
            dispatch({ type: 'SET_CONTACT_GROUP_ERRORS', data });
          } else {
            document.location.href = `/retailers/${ENV.SLUG}/contact_groups`;
          }
        },
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const updateContactGroup = (id, body, csrfToken) => {
  const endpoint = `/api/v1/contact_groups/${id}`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "PUT",
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/plain, */*'
      },
      body: JSON.stringify(body)
    })
      .then((res) => res.json())
      .then(
        (data) => {
          if (data.errors) {
            dispatch({ type: 'SET_CONTACT_GROUP_ERRORS', data });
          } else {
            document.location.href = `/retailers/${ENV.SLUG}/contact_groups`;
          }
        },
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const fetchCustomerList = (params = {}) => {
  const encodedParams = new URLSearchParams(params).toString();
  const endpoint = `/api/v1/contact_groups?${encodedParams}`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: 'GET_CUSTOMER_LIST', data }),
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const deleteCustomerList = (id) => {
  const endpoint = `/api/v1/contact_groups/${id}`;
  return (dispatch) => {
    fetch(endpoint, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
    })
    .then(handleRequestErrors)
    .then((data) => dispatch({ type: "DELETE_CUSTOMER_LIST", data })
    ).catch((err) => {
      dispatch({ type: "LOAD_DATA_FAILURE", err });
    });
  };
};

export const getSelectedCustomers = (params = {}) => {
  let endpoint = `/api/v1/contact_groups/selected_customers?`;
  selectedCustomersRequestId += 1;
  const requestId = selectedCustomersRequestId;

  if (params && Object.keys(params).length > 0) {
    endpoint += `&${$.param(params)}`;
  }

  return (dispatch) => {
    dispatch({ type: "START_SELECTED_CUSTOMERS_REQUEST", requestId });
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        Pragma: "no-cache"
      }
    })
      .then((res) => res.text().then((text) => {
        const data = text ? JSON.parse(text) : {};

        if (!res.ok) {
          return Promise.reject(data);
        }

        return data;
      }))
      .then(
        (data) => {
          dispatch({ type: 'SET_SELECTED_CUSTOMER_FOR_LIST', data, requestId });
          dispatch({ type: "END_SELECTED_CUSTOMERS_REQUEST", requestId });
        },
        (err) => {
          dispatch({ type: "END_SELECTED_CUSTOMERS_REQUEST", requestId });
          dispatch({ type: 'LOAD_DATA_FAILURE', err });
        }
      ).catch((error) => {
        dispatch({ type: "END_SELECTED_CUSTOMERS_REQUEST", requestId });
        dispatch({ type: 'LOAD_DATA_FAILURE', error });
      });
  };
};

export const getListCustomers = (webId, page) => {
  let endpoint = `/api/v1/contact_groups/${webId}/list_customers?page=${page}`;

  return (dispatch) => {
    dispatch({ type: "START_GET_LIST_CUSTOMERS_REQUEST" });
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => {
          dispatch({ type: "END_GET_LIST_CUSTOMERS_REQUEST" });
          dispatch({ type: 'SET_LIST_CUSTOMERS', data });
        },
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        dispatch({ type: "END_GET_LIST_CUSTOMERS_REQUEST" });
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const getPreviewCustomers = (params = {}) => {
  let endpoint = `/api/v1/contact_groups/preview_customers?`;
  if (params && params != {}) {
    // eslint-disable-next-line no-undef
    endpoint += `&${$.param(params)}`;
  }

  return (dispatch) => {
    dispatch({ type: "START_GET_PREVIEW_CUSTOMERS_REQUEST" });
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => {
          dispatch({ type: "END_GET_PREVIEW_CUSTOMERS_REQUEST" });
          dispatch({ type: 'SET_PREVIEW_CUSTOMERS', data })
        },
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        dispatch({ type: "END_GET_PREVIEW_CUSTOMERS_REQUEST" });
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const createCustomersList = (body, redirectPageUrl = '') => {
  let endpoint = `/api/v1/contact_groups`;

  return (dispatch) => {
    dispatch({ type: "START_SAVING_CUSTOMER_LIST_REQUEST" });
    fetch(endpoint, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
    .then(handleRequestErrors)
    .then(() => {
      dispatch({ type: "END_SAVING_CUSTOMER_LIST_REQUEST" });
      if (redirectPageUrl) {
        customHistory.push(redirectPageUrl);
      }
    }
    ).catch((error) => {
      dispatch({ type: "END_SAVING_CUSTOMER_LIST_REQUEST" });
      dispatch({ type: "LOAD_DATA_FAILURE", error });
    });
  };
};
